// Matches strings that contain only letters (A–Z, case-insensitive), digits (0–9),
// hyphens, and underscores. Used to validate identifier/slug inputs that must be
// safe for use in URLs, artifact IDs, and DynamoDB keys.
export const ALPHANUMERIC_DASH_UNDERSCORE = /^[a-z0-9_-]+$/i;

// Matches any whitespace character (spaces, tabs, newlines). Use with the `g`
// flag (already included) to strip all whitespace from a string.
export const WHITESPACE = /\s/g;
